import { Page, PageLink } from "@tfg/ui"
import { useTranslation } from "react-i18next"
import { Navigate, useParams } from "react-router-dom"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useFindProductByLegacyId } from "~/gen/api"
import { useProductQuery } from "~/pages/Brand/Products/Details/hooks.ts"

const isLegacyId = (id: string): boolean => {
  const num = parseInt(id, 10)
  return !isNaN(num) && num > 0 && num.toString() === id
}

const ProductDetailsLegacyWrapper = ({ productId }: { productId: number }) => {
  const legacyQuery = useFindProductByLegacyId(Number(productId))
  return (
    <DataFetchWrapper query={legacyQuery}>
      {({ data }) => {
        if (data.data?.uuid) {
          return <Navigate to={`/products/details/${data.data.uuid}`} replace />
        } else {
          return <Navigate to="/products" />
        }
      }}
    </DataFetchWrapper>
  )
}

const ProductDetails = ({ productId }: { productId: string }) => {
  const productQuery = useProductQuery(productId)
  const { t } = useTranslation("products")
  const pages: PageLink[] = [
    {
      label: t("details.tabs.general"),
      link: "general",
    },
  ]

  return (
    <DataFetchWrapper query={productQuery}>
      {({ data }) => (
        <Page title={data.name} pages={pages} data={data} canGoBack />
      )}
    </DataFetchWrapper>
  )
}

export const ProductDetailsWrapper = () => {
  const params = useParams()
  const productId = params.productId
  if (!productId) return <Navigate to="/products" />
  if (isLegacyId(productId)) {
    return <ProductDetailsLegacyWrapper productId={Number(productId)} />
  } else {
    return <ProductDetails productId={productId} />
  }
}
